module.exports = "https://static-production.npmjs.com/2f55441126e3c8d643c4c2d4e852cb4c.png";